import React from 'react';

import ActivityWrapper from '../activity-wrapper';
import { ACTIVITY_TYPES } from '../../../../../constants';
import NoteSection from '../note-section';
import problemActivityShape from '../../../../../shapes/problem-activity';
import { formatUsername } from '../../../../../utils/common';

/**
 * Problem Resolved Activity component.
 * @param {object} params - Object containing the props for this activity
 * @param {object} params.activity - Activity Data to display
 * @return {element}
 */
const ActivityProblemResolved = ({ activity }) => {
  const problemInfo = { text: `${formatUsername(activity.initiatorName)} resolved a problem`, descriptor: activity.problem };
  const lumperCode = activity.lumperCode ? { text: 'Lumper Code', descriptor: `${activity.lumperCode}` } : null;
  return (
    <ActivityWrapper
      type={ACTIVITY_TYPES.resolveProblem}
      headerContent={[problemInfo, lumperCode]}
      timestamp={activity.eventTime}
      testId="activity-problem-resolved"
    >
      <NoteSection note={activity.note} />
    </ActivityWrapper>
  );
};

ActivityProblemResolved.propTypes = {
  activity: problemActivityShape.isRequired,
};

export default ActivityProblemResolved;
